import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';

import { Col, Row } from 'antd';
import CustomFlatpickr from 'components/Form/Picker/CustomFlatpickr';

import Learningpath from './learningpath';
import OnboardStatus from './onboard-status';
import TopCentres from './top-centres';
import TotalOnboard from './total-onboard';
import { MdOutlineDateRange } from 'react-icons/md';
import { USER_METHODS } from 'constants/constants';
import { permissionOnboard } from './constants';
import { usePermissions } from 'hooks/permission/use-has-permission';
import { useRouter } from 'next/router';
import staffRequestApi from 'api/staffRequest';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedCentre } from 'store/master';
import { getOnBoardDateFilter, setOnBoardDateFilter } from 'store/global';
import { handleToastError } from 'helpers';

const OnboardGraph = dynamic(() => import('./onboard-graph'), { ssr: false });

const Onboard = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const [count, setCount] = useState();
  const selectedCentre = useSelector(getSelectedCentre);
  const onBoardDate = useSelector(getOnBoardDateFilter);

  const getOnboardDate = (date) => {
    dispatch(setOnBoardDateFilter(date));
  };
  const closeTime = (value) => {
    if (value?.length == 1) {
      dispatch(
        setOnBoardDateFilter([
          new Date(new Date().getTime() - 10 * 24 * 60 * 60 * 1000).setHours(
            0,
            0,
            0,
          ),
          new Date().setHours(0, 0, 0),
        ]),
      );
    }
  };

  const fetchDashboardCount = async (begin, end) => {
    try {
      let params = {
        ...(begin && { begin: new Date(begin)?.toISOString() }),
        ...(end && { end: new Date(end)?.toISOString() }),
        ...(selectedCentre && { courseCentre: selectedCentre?._id }),
        status: 'COMPLETED',
      };

      const response = await staffRequestApi.getDashboardCount(params);
      setCount(response);
    } catch (error) {
      handleToastError(error);
    }
  };

  useEffect(() => {
    if (onBoardDate?.length === 2) {
      fetchDashboardCount(
        new Date(onBoardDate[0]),
        new Date(onBoardDate[1]).setHours(23, 59, 59),
      );
    }
  }, [router?.query, selectedCentre, onBoardDate]);
  return (
    <>
      {/* Onboard Dashboard and Graph */}
      <div className="d-flex justify-content-between align-items-center mb-50">
        <h4 className="card-header-title-label mb-0">Onboard Dashboard</h4>
        <section className="date-range-card-dashboard-new d-flex mb-0">
          <span style={{ margin: '0px -5px 6px 10px', paddingTop: '4px' }}>
            <MdOutlineDateRange color="#8E96AA" size={25} />
          </span>
          <span style={{ marginTop: '3px' }}>
            <CustomFlatpickr
              time={onBoardDate}
              setTime={getOnboardDate}
              closeTime={closeTime}
            />
          </span>
        </section>
      </div>
      {/* Onboard status and Graph */}
      <Row gutter={[16, 16]}>
        <Col span={15} className="gutter-row">
          <Row gutter={[16, 16]}>
            <Col span={24} className="gutter-row">
              <TotalOnboard count={count} />
            </Col>
            <Col span={24} className="gutter-row">
              <OnboardStatus count={count} />
            </Col>
          </Row>
        </Col>
        <Col className="gutter-row" span={9}>
          <OnboardGraph count={count} />
        </Col>
      </Row>
      {/* Learning path and Top centre Onboard and Offboard */}
      <Row gutter={[16, 16]} className="mt-1">
        <Col className="gutter-row" span={15}>
          <Learningpath />
        </Col>
        <Col className="gutter-row" span={9}>
          <TopCentres />
        </Col>
      </Row>
    </>
  );
};

export default Onboard;
